import {
  saveRecharge as saveRechargeInAPI,
  fetchRechargeByLocale,
  saveRechargeWelcomeOffer as saveRechargeWelcomeOfferAPI,
  fetchRechargeWelcomeOfferByLocale
} from '@/api/webcontent'
import {
  sweepAllByKey
} from '@/api/web'

const saveRecharge = async ({ state }, locale) => {
  await saveRechargeInAPI(state.recharge, locale)
  await sweepAllByKey('recharge')
}

const setRecharge = ({ commit }, payload) => {
  commit('SET_RECHARGE_PROPERTY', payload)
}

const fetchRecharge = async ({ commit }, locale) => {
  let response = await fetchRechargeByLocale(locale)
  commit('SET_RECHARGE', response)
}

const saveRechargeWelcomeOffer = async ({ state }, locale) => {
  await saveRechargeWelcomeOfferAPI(state.rechargeWelcomeOffer, locale)
  await sweepAllByKey('recharge')
}

const setRechargeWelcomeOffer = ({ commit }, payload) => {
  commit('SET_RECHARGE_WELCOME_OFFER_PROPERTY', payload)
}

const fetchRechargeWelcomeOffer = async ({ commit }, locale) => {
  let response = await fetchRechargeWelcomeOfferByLocale(locale)
  commit('SET_RECHARGE_WELCOME_OFFER', response)
}

export default {
  saveRecharge,
  setRecharge,
  fetchRecharge,
  saveRechargeWelcomeOffer,
  setRechargeWelcomeOffer,
  fetchRechargeWelcomeOffer
}



// WEBPACK FOOTER //
// ./src/store/modules/recharge/actions.js